/**
 * Base abstract class defining the Reporter Provider interface.
 * Any reporting system (Bugsnag, Firebase Crashlytics, Sentry, Datadog, etc.)
 * must implement this contract.
 */
export class ReporterProvider {
  /**
   * Initialize the provider with configuration.
   * @param {Object} config
   */
  init(config) {
    throw new Error('Method init() must be implemented.');
  }

  /**
   * Send an error or exception to the reporting service.
   * @param {Error|string} error - The error to report
   * @param {Function|Object} [metadataOrOnError] - Optional metadata object or callback
   */
  notify(error, metadataOrOnError) {
    throw new Error('Method notify() must be implemented.');
  }

  /**
   * Identify current user for error tracking.
   * @param {Object} user - User information { id, name, email }
   */
  setUser(user) {
    throw new Error('Method setUser() must be implemented.');
  }

  /**
   * Clear identified user.
   */
  clearUser() {
    throw new Error('Method clearUser() must be implemented.');
  }

  /**
   * Add custom metadata to error reports.
   * @param {string} section - Tab/section name
   * @param {Object} data - Key/value pairs
   */
  addMetadata(section, data) {
    throw new Error('Method addMetadata() must be implemented.');
  }

  /**
   * Clear metadata section or key.
   * @param {string} section
   * @param {string} [key]
   */
  clearMetadata(section, key) {
    throw new Error('Method clearMetadata() must be implemented.');
  }

  /**
   * Leave a breadcrumb for tracking user actions leading up to an error.
   * @param {string} name - Name/description of breadcrumb
   * @param {Object} [metadata]
   * @param {string} [type]
   */
  leaveBreadcrumb(name, metadata, type) {
    throw new Error('Method leaveBreadcrumb() must be implemented.');
  }

  /**
   * Return the raw underlying client instance(s).
   * @returns {any}
   */
  getClient() {
    throw new Error('Method getClient() must be implemented.');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/monitoring/contracts/ReporterProvider.js